import { useMutation } from '@tanstack/react-query';
import { ErrorObject } from '../@types/api';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import useLocalization from '../hooks/useLocalization';
import { useExtendedSnackbar } from '../hooks/useExtendedSnackbar';

type LoginPayload = {
  email: string;
  password: string;
};

export const useLogin = (onSuccessCallback?: () => void) => {
  const { handleLogin } = useAuth();
  const { t } = useLocalization();
  const { showErrorMessage } = useExtendedSnackbar();

  return useMutation<unknown, ErrorObject, LoginPayload>({
    mutationFn: (data: LoginPayload) => handleLogin(data.email, data.password),
    onSuccess: async () => {
      onSuccessCallback?.();
    },
    onError: (error) => {
      let errorMessage = t('register.validation.unexpectedErrorOccurred');
      if (error.code) {
        errorMessage = error.code;
      }
      showErrorMessage(errorMessage, { variant: 'error' });
    },
  });
};
